import { SET_NOTIFICATION, CLOSE_NOTIFICATION } from './types'

const initialState = {
  notification: {},
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      }

    case CLOSE_NOTIFICATION:
      return {
        ...state,
        notification: { ...state.notification, closeNotification: true },
      }

    default:
      return state
  }
}
export default reducer
